var render = function render(){var _vm=this,_c=_vm._self._c;return (!!_vm.edited_record)?_c('div',[_c('plans')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }